export default {
  methods: {
    removeAdditionalChars(text, char) {
      return this.capitalizeFirstLetter(text).replace(char, " ");
    },
    editBulkCancel() {
      this.isCardModalBulkEditActive = false;
      this.checkedRow = [];
      this.isCheckedAll = false;
    },

    editBulkModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.action = "Edit";
        this?.importData?.import_type == "Transactions"
          ? (this.isCardModalBulkEditActive = false)
          : (this.isCardModalBulkEditActive = true);
      } else {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "Please choose the record(s) you want to update.",
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },

    find_column_config_index(column_name) {
      return this.columnsConfig.findIndex(
        col => col.product_data_column.trim() === column_name.trim()
      );
    },
    getDependantFieldValue(item) {
      if (
        this.columnsConfig[this.dependentIndex] &&
        this.columnsConfig[this.dependentIndex]["dropdown_field_values"] &&
        this.columnsConfig[this.dependentIndex]["dropdown_field_values"][0] &&
        this.columnsConfig[this.dependentIndex]["dropdown_field_values"][0][
          item
        ]
      ) {
        const subCategoryList = this.columnsConfig[this.dependentIndex][
          "dropdown_field_values"
        ][0][item];
        if (subCategoryList.length > 0) {
          this.subCategoryList = subCategoryList;
        }
      }
    }
  }
};
